/* src/app/reminder/reminder-add/reminder-add.component.scss */
/*# sourceMappingURL=reminder-add.component.css.map */
